module.exports = "../../app/cells/components/banner/oab_questions_banner_cell.rb";